import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const actionsGridWrapper = style({
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
  columnGap: vars.space.xs,
  width: "100%",
});

export const checkBoxItem = style({
  padding: vars.space.m,
  selectors: {
    "&::after": {
      position: "absolute",
      insetInlineStart: vars.space.m,
      insetInlineEnd: vars.space.m,
      backgroundColor: vars.colors.outlineVariant,
      height: 1,
      content: '""',
    },
  },
});
